import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faXmark } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom"
import NotificationCard from "./NotificationCard";

function Notification({isOpen, toggleNotification }) {
    const [notifications, setNotifications] = useState([])
    const deleteNotification = (id) => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ deleteNot: true, notid : id })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setNotifications(notifications.filter(notification => notification.id !== id));
        }
      })
      .catch(err => {
        console.error(err)
      })
    };
    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchNotification: true })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setNotifications(data.notifications);
        }
      })
      .catch(err => {
          console.error(err)
      })
    }, []);
    return (
      <div className={`notifybar ${isOpen ? "active" : null}`}>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}} onClick={toggleNotification}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">Notifications</p>
            </div>
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={toggleNotification}/>
          </div>
          <div className="sidebar-navbar" style={{height: '85%'}}>
          {notifications.length > 0 ? (
            notifications.map((notification) => (
                <NotificationCard 
                key={notification.id} 
                {...notification} 
                onDelete={() => deleteNotification(notification.id)} 
                />
            ))
            ) : (
            <p className="text-secondary text-center fw-bold text-white mt-5 w-100" style={{fontSize: '14px'}}>No new notifications</p>
            )}
          </div>
          <div className='notifybar-bottom'>
          </div>
      </div>
    )
}

export default Notification